import { c as _c } from "react/compiler-runtime";
import type { MergeDropdownCheckRun } from './types';
import { cn } from '@/lib/utils';

/**
 * Displays the annotations (summary, text, and line-by-line annotations) for a single check run.
 *
 * @param {object} props
 * @param {CheckRun} props.checkRun - The check run whose annotations should be displayed.
 * @returns {JSX.Element | null} A component showing the annotations, or `null` if none are available.
 */
export function CheckAnnotations(t0) {
  const $ = _c(17);
  const {
    checkRun
  } = t0;
  let t1;
  if ($[0] !== checkRun.output) {
    t1 = checkRun.output ?? {};
    $[0] = checkRun.output;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    summary,
    text
  } = t1;
  let t2;
  if ($[2] !== checkRun.annotations) {
    t2 = Array.isArray(checkRun.annotations) ? checkRun.annotations : [];
    $[2] = checkRun.annotations;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const annotations = t2;
  if (!summary && !text && annotations.length === 0) {
    return null;
  }
  let t3;
  if ($[4] !== checkRun.name) {
    t3 = <div className="font-medium">{checkRun.name}</div>;
    $[4] = checkRun.name;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== summary) {
    t4 = summary && <div className="text-sm text-muted-foreground">{summary}</div>;
    $[6] = summary;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== text) {
    t5 = text && <div className="whitespace-pre-wrap text-sm">{text}</div>;
    $[8] = text;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== annotations) {
    t6 = annotations.length > 0 && <div className="space-y-2">{annotations.map(_temp)}</div>;
    $[10] = annotations;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className="max-w-[400px] space-y-2 p-1">{t3}{t4}{t5}{t6}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp(annotation, index) {
  const isFailure = annotation.annotation_level === "failure";
  const isWarning = annotation.annotation_level === "warning";
  return <div key={index} className="text-sm"><div className={cn(isFailure && "text-red-400", isWarning && "text-yellow-400")}>{annotation.message}</div></div>;
}